export default (state) => {
  if (!state.subscriptions || !state.subscriptions.current) {
    return undefined;
  }

  const { descriptors } = state.subscriptions.current;

  return descriptors;
};
